<div fxLayout="row" fxLayoutAlign="center" class="step-header">Welcome To VEIL!</div>
<div fxLayout="row" fxLayoutAlign="center">
  <span class="sub-header" fxFlex="40%">holder</span>
</div>
<div fxLayout="row" fxLayoutAlign="center" style="margin-bottom: 3%">
  <p>Please set up your account to get started!</p>
</div>

<form [formGroup]="userForm" (submit)="onSubmit()" fxLayout="column">
  <div fxLayout="row" fxLayoutGap="2%">
    <mat-form-field fxFlex="49%" appearance="outline">
      <mat-label>First Name</mat-label>
      <input matInput type="text" placeholder="First Name" name="firstName" formControlName="firstName" required />
      <mat-error
        *ngIf="
          userForm.get('firstName').invalid && (userForm.get('firstName').dirty || userForm.get('firstName').touched)
        "
      >
        First name is required
      </mat-error>
    </mat-form-field>

    <mat-form-field fxFlex="49%" appearance="outline">
      <mat-label>Last Name</mat-label>
      <input matInput type="text" placeholder="Last Name" name="lastName" formControlName="lastName" required />
      <mat-error
        *ngIf="userForm.get('lastName').invalid && (userForm.get('lastName').dirty || userForm.get('lastName').touched)"
      >
        Last name is required
      </mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100%" appearance="outline">
      <mat-label>Email</mat-label>
      <input
        matInput
        type="email"
        placeholder="Email Address"
        name="email"
        autocomplete="email"
        formControlName="email"
        [errorStateMatcher]="matcher"
        [enrollEmailDuplicate]="toVerifyEmail"
        (keyup)="emailKeyupHandler(userForm.get('email').value)"
        (blur)="emailBlurred(userForm.get('email').value)"
        (focus)="emailFocus(userForm.get('email').value)"
        email
        required
      />
      <mat-error
        *ngIf="userForm.get('email').invalid && (userForm.get('email').touched || userForm.get('email').dirty)"
      >
        <div *ngIf="userForm.get('email').errors.required">Email is required</div>
        <div *ngIf="userForm.get('email').errors.email">Enter a valid email address</div>
        <div *ngIf="userForm.get('email').errors.emailDuplicate">That email address has already been enrolled</div>
      </mat-error>
    </mat-form-field>
  </div>
  <mat-form-field appearance="outline" class="app-form-field">
    <mat-label>Advertiser Name</mat-label>
    <form [formGroup]="advertiserForm">
      <input matInput name="advertiser" placeholder="Advertiser Name" formControlName="name" required />
    </form>
    <mat-error
      *ngIf="
        advertiserForm.get('name').invalid && (advertiserForm.get('name').touched || advertiserForm.get('name').dirty)
      "
    >
      <div *ngIf="advertiserForm.get('name').errors.required">Advertiser is required</div>
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline" class="app-form-field">
    <mat-label>Password</mat-label>
    <input
      matInput
      name="password"
      formControlName="password"
      [type]="showPass ? 'text' : 'password'"
      [attr.aria-label]="'email'"
      (ngModelChange)="onPasswordChange($event)"
      required
    />
    <span matSuffix class="cursor-pointer" (keydown.enter)="togglePass()" (click)="togglePass()">
      <ng-container *ngIf="showPass">
        <mat-icon>visibility</mat-icon>
      </ng-container>
      <ng-container *ngIf="!showPass">
        <mat-icon>visibility_off</mat-icon>
      </ng-container>
    </span>
  </mat-form-field>

  <ng-container>
    Passwords must contain:
    <div
      class="pifc-error-display"
      [ngClass]="
        userForm.get('password').touched || userForm.get('password').dirty
          ? (userForm.get('password').errors && userForm.get('password').errors.atLeastOneCapital) ||
            !userForm.get('password').errors
            ? 'app-success-color'
            : 'app-error-color'
          : 'app-default-color'
      "
    >
      <span>
        <mat-icon *ngIf="userForm.get('password').touched || userForm.get('password').dirty">{{
          (userForm.get('password').errors && userForm.get('password').errors.atLeastOneCapital) ||
          !userForm.get('password').errors
            ? 'check'
            : 'close'
        }}</mat-icon>
      </span>
      <p>At least one capital letter</p>
    </div>
    <div
      class="pifc-error-display"
      [ngClass]="
        userForm.get('password').touched || userForm.get('password').dirty
          ? (userForm.get('password').errors && userForm.get('password').errors.atLeastOneLower) ||
            !userForm.get('password').errors
            ? 'app-success-color'
            : 'app-error-color'
          : 'app-default-color'
      "
    >
      <span>
        <mat-icon *ngIf="userForm.get('password').touched || userForm.get('password').dirty">{{
          (userForm.get('password').errors && userForm.get('password').errors.atLeastOneLower) ||
          !userForm.get('password').errors
            ? 'check'
            : 'close'
        }}</mat-icon>
      </span>
      <p>At least one lower case letter</p>
    </div>
    <div
      class="pifc-error-display"
      [ngClass]="
        userForm.get('password').touched || userForm.get('password').dirty
          ? (userForm.get('password').errors && userForm.get('password').errors.atLeastOneNumberOrSymbol) ||
            !userForm.get('password').errors
            ? 'app-success-color'
            : 'app-error-color'
          : 'app-default-color'
      "
    >
      <span>
        <mat-icon *ngIf="userForm.get('password').touched || userForm.get('password').dirty">{{
          (userForm.get('password').errors && userForm.get('password').errors.atLeastOneNumberOrSymbol) ||
          !userForm.get('password').errors
            ? 'check'
            : 'close'
        }}</mat-icon>
      </span>
      <p>At least one number or symbol</p>
    </div>
    <div
      class="pifc-error-display"
      [ngClass]="
        userForm.get('password').touched || userForm.get('password').dirty
          ? (userForm.get('password').errors && userForm.get('password').errors.atLeastEight) ||
            !userForm.get('password').errors
            ? 'app-success-color'
            : 'app-error-color'
          : 'app-default-color'
      "
    >
      <span>
        <mat-icon *ngIf="userForm.get('password').touched || userForm.get('password').dirty">{{
          (userForm.get('password').errors && userForm.get('password').errors.atLeastEight) ||
          !userForm.get('password').errors
            ? 'check'
            : 'close'
        }}</mat-icon>
      </span>
      <p>Be at least 8 characters</p>
    </div>
  </ng-container>

  <mat-checkbox id="terms-checkbox" name="terms" formControlName="termsAccepted" required
    >I accept the <a href="#" (click)="showTerms($event)">Terms & Conditions</a></mat-checkbox
  >
</form>

<mat-card-actions fxLayout="row" fxLayoutAlign="end" fxFlexAlign="end">
  <button
    matStepperNext
    mat-raised-button
    color="primary"
    [disabled]="!userForm.valid"
    (click)="onSubmit()"
    [appShowSpinner]="loading"
    [buttonText]="'CONTINUE'"
  >
    CONTINUE
  </button>
</mat-card-actions>
